/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <LogoGrid {...cmsData} />)
 * and then make these props fit the final module.
 */
import React from "react"
import { Section, CmsImage } from "@bw/bits"
import { graphql } from "gatsby"
import { LogoGrid as LogoGridModule } from "@bw/modules"

const LogoGrid = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  backgroundVariant,
  logos,
}) => {
  return (
    <Section
      {...{
        suptitle,
        title,
        subtitle,
        button,
        buttonPosition,
        backgroundVariant,
      }}
    >
      <LogoGridModule
        contents={logos.map(logo => ({
          image: <CmsImage src={logo.image} alt={logo.image.alt} />,
          alt: logo.image.alt,
          to:
            logo.linkType.value === "entry" && logo.entry?.slug
              ? `/${logo.entry.slug}/`
              : null,
          href: logo.linkType.value === "url" ? logo.url : null,
        }))}
      />
    </Section>
  )
}

/**
 * This generates a GraphQL Fragment that can be used in a page query:
 *
 * Example:
 * ... on LogoGridModule {
 *   ...LogoGridModuleFragment
 * }
 *
 * This is also what you will get in the props of your LogoGrid
 * resolver component.
 */
export const query = graphql`
  fragment LogoGridModuleFragment on LogoGridModule {
    logos {
      image {
        localImage {
          childImageSharp {
            gatsbyImageData(width: 200)
          }
        }
      }
      isExternal
      linkType {
        value
      }
      url
      entry {
        slug
      }
    }
  }
`

export { LogoGrid }
